export default __webpack_public_path__ + "static/media/widget_watchbox_vpmndx5_buy.fb29fd3b.mp3";